import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltAutocompleteOptionIconWireframe from './VeltAutocompleteOptionIconWireframe/VeltAutocompleteOptionIconWireframe';
import VeltAutocompleteOptionNameWireframe from './VeltAutocompleteOptionNameWireframe/VeltAutocompleteOptionNameWireframe';
import VeltAutocompleteOptionDescriptionWireframe from './VeltAutocompleteOptionDescriptionWireframe/VeltAutocompleteOptionDescriptionWireframe';
import VeltAutocompleteOptionErrorIconWireframe from './VeltAutocompleteOptionErrorIconWireframe/VeltAutocompleteOptionErrorIconWireframe';
var VeltAutocompleteOptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-option-wireframe", __assign({}, transformedProps), children));
};
VeltAutocompleteOptionWireframe.Icon = VeltAutocompleteOptionIconWireframe;
VeltAutocompleteOptionWireframe.Description = VeltAutocompleteOptionDescriptionWireframe;
VeltAutocompleteOptionWireframe.ErrorIcon = VeltAutocompleteOptionErrorIconWireframe;
VeltAutocompleteOptionWireframe.Name = VeltAutocompleteOptionNameWireframe;
export default VeltAutocompleteOptionWireframe;
